import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import PageRoutes from "../../../../utils/routes";

const JobBreadcrumb = ({ title }) => {
  const breadcrumbStyle = {
    padding: "16px 60px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #f0f0f0",
  };

  return (
    <div style={breadcrumbStyle}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={PageRoutes.personnelHome}>Ana Sayfa</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={PageRoutes.listings}>İş İlanları</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{title}</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );
};

export default JobBreadcrumb;
